var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "div",
        { staticClass: "py-1 d-flex justify-content-end" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.modal-addcategory",
                  modifiers: { "modal-addcategory": true },
                },
              ],
              attrs: {
                variant: "primary",
                "activev-ripple.400": "'rgba(113, 102, 240, 0.15)'",
              },
            },
            [
              _c("i", { staticClass: "feather icon-plus" }),
              _vm._v(" Add New Category "),
            ]
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "b-col",
            { staticClass: "my-1", attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "3",
                    "label-align-sm": "right",
                    "label-size": "sm",
                    "label-for": "filterInput",
                  },
                },
                [
                  _c(
                    "b-input-group",
                    { attrs: { size: "sm" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "filterInput",
                          type: "search",
                          placeholder: "Type to Search",
                        },
                        model: {
                          value: _vm.filter,
                          callback: function ($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-table", { attrs: { responsive: "lg", items: _vm.items } }),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center" },
        [
          _c("b-pagination", {
            attrs: { "hide-goto-end-buttons": "", "total-rows": _vm.rows },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-addcategory",
            "cancel-variant": "outline-secondary",
            "ok-title": "Add",
            "cancel-title": "Close",
            centered: "",
            title: "Add Category",
          },
        },
        [
          _c(
            "b-form",
            [
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "Category" } }, [
                    _vm._v("Category ID"),
                  ]),
                  _c("b-form-input", {
                    attrs: {
                      id: "text",
                      type: "text",
                      placeholder: "3192DG",
                      readonly: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "Name" } }, [
                    _vm._v("Category Name"),
                  ]),
                  _c("b-form-input", {
                    attrs: { type: "text", placeholder: "Category 6" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }